import { render, staticRenderFns } from "./UserDetails.vue?vue&type=template&id=2c9cf38f&scoped=true"
import script from "./UserDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserDetails.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./UserDetails.vue?vue&type=style&index=0&id=2c9cf38f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9cf38f",
  null
  
)

export default component.exports